import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSplitsMain } from './modules/ui/Main';

const SplitsPage = (
  <SuspensePage>
    <PagesSplitsMain />
  </SuspensePage>
);

export default SplitsPage;
